<template>
  <div class="app-footer" >
    <EmbeddableFooter v-if="enableFooter" :sharing-options-values="sharingOptionsValues">
      <div class="d-none d-sm-block">
        <BButton variant="link" pill class="text-white float-right mr-1 font-weight-bold" @click.prevent="toggleAbout">
          {{ $t('appFooter.about') }}
        </BButton>
        <BButton variant="link" pill class="text-white float-right mr-1 font-weight-bold" @click.prevent="toggleCredits">
          {{ $t('appFooter.credits') }}
        </BButton>
      </div>
    </EmbeddableFooter>  
  </div>
</template>

<script>
import get from 'lodash/get'
import snarkdown from 'snarkdown'
import utils from '@/mixins/utils'

export default {
  name: 'AppFooter',
  mixins: [utils],
  data () {
    return {
      enableFooter: false,
      showAbout: false,
      showCredits: false
    }
  },
  computed: {
    about () {
      return snarkdown(this.$t('about.body'))
    },
    credits () {
      return snarkdown(this.$t('credits.body'))
    },
    imageUrl () {
      return this.getFullUrl('fincen_files_social.png')
    },
    sharingOptionsValues() {
      return {
        url: this.url,
        title: 'Meet the fugitive financier, oligarchs, business tycoons and entrepreneurs in the FinCEN Files.',
        description: 'These are the people zippig money across the world thanks to the global banking system. ' + this.url,
        image: this.imageUrl,
        twitter_title: 'A cryptocurrency queen, a fugitive financier, politicians, business tycoons, and more. @ICIJorg found them all in the #FinCENFiles',
        twitter_description: 'These people are using the world\'s biggest banks to zip money across the globe.'
      }
    },
    url () {
      return this.getFullUrl(this.$router.resolve({ name: 'list' }).href)
    }
  },
  methods: {
    toggleAbout () {
      this.showAbout = !this.showAbout
    },
    toggleCredits () {
      this.showCredits = !this.showCredits
    }
  },
  beforeMount () {
    const enableFooter = get(this.$route, ['query', 'enableFooter'], false)
    this.$set(this, 'enableFooter', String(enableFooter).toLowerCase() === 'true')
  },
}
</script>

<style lang="scss" scoped>
  .newsletter-block {
    padding: 15vh 0;
    background: var(--app-color-light);

    .newsletter-form {
      max-width: 520px;
      margin: 0 auto;
      padding: 0 15px;

      label {
        font-size: 41px;
      }
    }
  }

  .pandora-paper-block {    
    padding: 15vh 0;
    background-color:  #ffffffad;

    .pandora-content {
      max-width: 720px;
      margin: 0 auto;

      h4 {
        padding: 5px 15px;
        font-size: 19px;
      }
    }
  }

  .generic-footer {
    overflow-x: hidden;
    img {
      @media (max-width: 767.98px) {
        width: auto !important;
        height: 31px !important;
      }
    }
  }

  .app-footer {
    /deep/ .embeddable-footer {
      background: inherit;
      position: relative;
      z-index: -1;

      & > .embeddable-footer__lead {
        overflow: visible;
      }

      & > .embeddable-footer__brand {
        border-right: 0;
        font-family: var(--font-family-sans-serif);

        svg {
          margin: 0 .5rem;
          transform: scale(1.5);
        }
      }
    }

    &__about {
      /deep/ {
        h1 {
          font-size: 2rem;
          margin-top: 5vh;
        }

        h2 {
          font-size: 1.5rem;
          margin-top: 3vh;
        }

        li {
          margin-bottom: 1.5rem;
        }
      }
    }
  }
</style>
